/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { ITenantPaymentGateway } from 'app/shared/model/tenant-payment-gateway.model';
import { IClinicalDictionary } from 'app/shared/model/clinical-dictionary.model';
import { TransactionCategory } from 'app/shared/model/enumerations/transaction-category.model';

export interface ITenantGatewayTransaction {
  id?: string;
  success?: boolean | null;
  code?: string | null;
  message?: string | null;
  transactionId?: string | null;
  transactionType?: keyof typeof TransactionCategory;
  merchantId?: string | null;
  providerReferenceId?: string | null;
  amount?: number | null;
  payResponseCode?: string | null;
  trdPtyUtr?: string | null;
  qrCodeId?: string | null;
  storeId?: string | null;
  terminalId?: string | null;
  userId?: string | null;
  gatewayResponse?: string | null;
  tenantId?: string | null;
  active?: boolean | null;
  draft?: boolean;
  cursor?: number | null;
  lastUpdated?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  bankId?: string | null;
  bankTransactionId?: string | null;
  pgTransactionId?: string | null;
  pgInstrumentType?: string | null;
  gateway?: ITenantPaymentGateway | null;
  paymentMode?: IClinicalDictionary | null;
  paymentState?: IClinicalDictionary | null;
}

export const defaultValue: Readonly<ITenantGatewayTransaction> = {
  success: false,
  active: false,
  draft: false,
};
